var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImgSearchNotfound = function SvgImgSearchNotfound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M138.343 153.206c0 10.932-21.209 19.794-47.37 19.794-26.163 0-47.371-8.862-47.371-19.794s21.208-19.794 47.37-19.794 47.371 8.862 47.371 19.794"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M138.768 122.284c-.03-2.343.077-20.948-6.737-38.093-5.144-12.942-16.698-43.368-21.714-56.76-2.888-7.71-4.792-16.33-9.178-23.274-6.79-10.75-11.118 2.286-10.676 9.613l-.21.08c-14.785 1.61-25.47 10.882-25.47 10.882-4.448-5.729-16.229-12.59-14.278-.005 1.26 8.13 5.531 14.595 8.48 22.47l.015-.005c4.916 13.125 8.57 14.453 9.845 25.982.379 3.425-1.704 8.304-5.51 11.998l.015-.443c-20.133 1.87-29.779 10.843-28.865 23.628.593 8.305 7.43 14.503 18.1 15.616v2.127l-.91-1.635s-.524 6.668-.066 13.159l-.132-.063c.133 4.19.637 8.648 2.051 10.791 1.863 2.824 6.711 5.484 13.427 6.084l-.055-.159c.473.056.954.109 1.449.16l-3.747-6.736-.8-2.287h.515c3.697 10.485 9.154 13.938 14.285 16.368 7.898 3.74 15.642 4.524 27.411 3.277 31.457-3.333 32.832-36.463 32.755-42.775"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8925F",
    d: "M62.96 141.205c-6.04-.779-9.173-3.314-11.018-4.111.133 4.189.637 8.648 2.05 10.79 1.864 2.825 6.712 5.485 13.428 6.085l-4.46-12.764z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.337,
    d: "M47.56 93.21C63.26 88.644 67.21 81.386 69 75.122c2.376-8.31-16.45-41.685-18.04-49.757-2.46-12.494 9.567-6.176 14.245-.636 0 0 10.333-8.356 25.04-10.575l.206-.088c-.74-7.304 3.1-20.398 10.321-9.938 4.665 6.758 7.406 15.346 10.605 22.93 5.557 13.175 15.51 43.695 20.654 56.636 6.814 17.145 6.708 35.765 6.736 38.107.078 6.312-1.297 39.45-32.753 42.783-11.77 1.247-19.514.467-27.412-3.273-7.547-3.574-15.796-9.352-18.12-36.47"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.337,
    d: "M62.071 123.237C46.08 125.62 35.24 118.45 34.485 107.89c-.914-12.785 8.732-21.758 28.865-23.628"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.337,
    d: "M52.139 123.998s-1.366 17.383 2.241 23.332c2.997 4.944 7.717 5.956 14.434 6.639"
  }))));
};
export default SvgImgSearchNotfound;